import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponsService_GetCouponsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/wallet/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../ReductionsState/useReductionsStateRequestParameter';
import {useIsCouponWalletActive} from './useIsCouponWalletActive';

export const useGetCoupons = () => {
  const fullSession = useFullSession();
  const isCouponWalletActive = useIsCouponWalletActive();

  return useGrpcRequest(
    CouponsService_GetCouponsLazy,
    {
      reductionsState: useReductionsStateRequestParameter(),
      session: fullSession!,
    },
    {
      disabled: !fullSession || !isCouponWalletActive,
    },
  );
};
